export default __webpack_public_path__ + "static/media/Check.6f94542b.svg";